import "../css/Tesla.css"

import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function MainTesla() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="tesla-page">
            {/* Hero Section - Two Columns */}
            <section className="tesla-hero-split">
                <div className="container">
                    <div className="tesla-hero-row">
                        {/* Logo Column */}
                        <div className="tesla-hero-logo">
                            <img src="tesla.png" alt="Tesla" className="tesla-wordmark" />
                        </div>
                        {/* Text Column */}
                        <div className="tesla-hero-content">
                            <div className="tesla-hero-text-box">
                                <p>
                                    La Carrozzeria Bulletti fa parte del Body Shop Approved Network Tesla. La nostra carrozzeria ha superato gli alti standard qualitativi, dopo la formazione e la valutazione da parte di Tesla Motors del personale, visto che le auto elettriche esigono particolari accorgimenti durante la riparazione e possono essere riparate soltanto da personale altamente qualificato e formato.
                                </p>
                                <p>
                                    L'alta tecnologia progettuale di ogni Tesla necessita di cure dedicate e le riparazioni alla carrozzeria non riguardano solo l'estetica dell'auto ma anche la sicurezza. Una carrozzeria Autorizzata Tesla deve avere equipaggiamenti adeguati e personale preparato a ricostruire ogni danno alla vettura secondo gli standard di costruzioni imposti da Tesla, garantendone l'integrità strutturale, la qualità delle finiture e le procedure di assemblaggio approvate dalla casa madre.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Section - 3 Cards */}
            <section className="tesla-why-section">
                <div className="container">
                    <h2>Perché Scegliere una Carrozzeria Approvata Tesla</h2>
                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6">
                            <div className="tesla-benefit-card">
                                <div className="tesla-benefit-icon">
                                    <i className="fa-solid fa-shield-halved"></i>
                                </div>
                                <h3>Nessuna Perdita di Garanzia</h3>
                                <p>Le riparazioni sono eseguite scrupolosamente secondo le direttive originali Tesla, mantenendo intatta la garanzia del veicolo.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="tesla-benefit-card">
                                <div className="tesla-benefit-icon">
                                    <i className="fa-solid fa-certificate"></i>
                                </div>
                                <h3>Ricambi Originali</h3>
                                <p>Una Tesla può essere riparata solo con ricambi originali certificati, garantendo la qualità costruttiva e le prestazioni originali del veicolo.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="tesla-benefit-card">
                                <div className="tesla-benefit-icon">
                                    <i className="fa-solid fa-user-graduate"></i>
                                </div>
                                <h3>Personale Qualificato</h3>
                                <p>Riparazioni eseguite da tecnici formati direttamente da Tesla Motors attraverso corsi di formazione specifici e certificazioni professionali.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Tech Section - Dark Background */}
            <section className="tesla-tech-section">
                <div className="container">
                    <h2>Tecnologia e Competenza Certificata</h2>
                    <p>
                        Tesla realizza veicoli con un livello qualitativo eccezionale. La progettazione di telaio e carrozzeria è basata su tecnologie avanzate dell'alluminio: pressofuso strutturale, estruso e stampato, assemblato con tecnologie all'avanguardia per la saldatura dell'alluminio.
                    </p>
                    <p>
                        Le parti in fusione di alluminio della struttura e le lamiere assemblate garantiscono una resistenza eccezionale, offrendo la massima sicurezza ai passeggeri. Per trattare l'alluminio e i veicoli elettrici ad alta tensione, la nostra officina dispone di un'infrastruttura speciale e di attrezzature dedicate.
                    </p>
                    <p>
                        Solo le aziende che soddisfano standard elevatissimi possono essere un Tesla Approved Body Shop ed eseguire riparazioni secondo le direttive originali. Per questo motivo, i nostri tecnici seguono specifici corsi di formazione erogati da Tesla e superano rigorosi esami di saldatura per ottenere il certificato di approvazione.
                    </p>
                </div>
            </section>

            {/* CTA Section */}
            <section className="tesla-cta-section">
                <Link to="../contatti" className="tesla-cta-button">
                    Contattaci subito
                </Link>
            </section>

            {/* Services Section - 4 Cards */}
            <section className="tesla-services-section">
                <div className="container">
                    <h2>I Nostri Servizi Tesla</h2>
                    <div className="row g-4">
                        <div className="col-lg-6 col-md-6">
                            <div className="tesla-service-card">
                                <h3>Riparazione Carrozzeria Post-Incidente</h3>
                                <p>Riparazioni complete della carrozzeria secondo gli standard Tesla per danni da collisione, garantendo l'integrità strutturale e la sicurezza originale del veicolo.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="tesla-service-card">
                                <h3>Verniciatura con Colori Originali Tesla</h3>
                                <p>Verniciatura professionale eseguita con colori originali Tesla e lucidatura con trattamento al silicio per una finitura impeccabile e duratura.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="tesla-service-card">
                                <h3>Sostituzione Parabrezza e Ricalibrazione ADAS</h3>
                                <p>Le auto Tesla integrano sistemi di assistenza alla guida avanzati nel parabrezza. Sostituiamo e ricalibramo i sistemi ADAS con strumentazione certificata Tesla.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="tesla-service-card">
                                <h3>Cerchi e Pneumatici Originali Tesla</h3>
                                <p>Fornitura e montaggio di cerchi originali Tesla e pneumatici dedicati, progettati specificamente per le prestazioni e l'efficienza delle auto elettriche.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}
